import { Form } from "antd";

import type { DynamicPropertiesFieldAttributes, FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { DynamicProperties } from "./DynamicProperties";

export const DynamicPropertiesField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    const attributes = field.attributes as DynamicPropertiesFieldAttributes;

    const hasRequiredRule = rules?.some((rule) => typeof rule !== "function" && "required" in rule && rule.required === true) ?? false;

    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <DynamicProperties
                key={field.name}
                label={field.translationKeys.label}
                readOnly={readOnly}
                useReadOnly={attributes?.useReadOnly}
                hasRequiredRule={hasRequiredRule}
            />
        </Form.Item>
    );
};
